import { Component, input } from '@angular/core';

import { Booking } from '../../../models/domain.models';

@Component({
  selector: 'vx-booking-table',
  standalone: true,
  template: `
    <div class="table-wrap">
      <table>
        <thead>
          <tr><th>ID</th><th>Locker</th><th>QR</th><th>PIN</th><th>Pagamento</th></tr>
        </thead>
        <tbody>
          @for (booking of bookings(); track booking.id) {
            <tr>
              <td>#{{ booking.id }}</td>
              <td>{{ booking.locker_id }}</td>
              <td><code>{{ booking.qr_code }}</code></td>
              <td>{{ booking.pin_code }}</td>
              <td><span class="status" [class]="booking.pagamento_stato">{{ booking.pagamento_stato }}</span></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  `,
  styles: [`
    .table-wrap {
      overflow: auto;
      border: 1px solid var(--vx-line);
      border-radius: 8px;
      background: white;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      min-width: 620px;
    }
    th, td {
      padding: 14px 16px;
      text-align: left;
      border-bottom: 1px solid var(--vx-line);
    }
    th {
      color: var(--vx-muted);
      font-size: .78rem;
      text-transform: uppercase;
      letter-spacing: .06em;
    }
    code {
      color: var(--vx-primary);
      font-weight: 800;
    }
  `]
})
export class BookingTableComponent {
  bookings = input.required<Booking[]>();
}
